module.exports = __webpack_public_path__ + "img/hat-icon_2.559934ac.png";